var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.308,
    height: 27.045,
    viewBox: "0 0 29.308 27.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-up",
    transform: "translate(-2.25 -4.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M15.113,7.987A1.125,1.125,0,0,1,15.75,9V27a1.125,1.125,0,0,1-1.827.878L8.606,23.625H3.375A1.125,1.125,0,0,1,2.25,22.5v-9a1.125,1.125,0,0,1,1.125-1.125H8.606l5.317-4.252a1.125,1.125,0,0,1,1.19-.135ZM13.5,11.34,9.7,14.377a1.125,1.125,0,0,1-.7.248H4.5v6.75H9a1.125,1.125,0,0,1,.7.247l3.8,3.038Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M25.956,31.523a19.121,19.121,0,0,0,0-27.045L24.362,6.069a16.871,16.871,0,0,1,0,23.863l1.593,1.591Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M22.772,28.341a14.623,14.623,0,0,0,0-20.682L21.181,9.25a12.378,12.378,0,0,1,0,17.5l1.588,1.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M19.591,25.16a10.125,10.125,0,0,0,0-14.319L18,12.431a7.878,7.878,0,0,1,0,11.138Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume-up.0107243d9ad9c7b3085973592f96a3c2.svg";
export { ForwardRef as ReactComponent };